export const COVID_SITE_MANAGER_PATH = '/covid-site-manager';
